import TiktokLandingPage from './TiktokLandingPage';

export default TiktokLandingPage;
